var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    fill: "#FFFFFF",
    cx: 75,
    cy: 75.2,
    r: 74.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fill: "#29D773",
    d: "M96.8,57.5l-5.3-5.3l-24,24l5.3,5.3L96.8,57.5z M112.9,52.1L72.8,92.2L57,76.4l-5.3,5.3 l21.2,21.2l45.4-45.5L112.9,52.1z M30.2,81.8l21.2,21.2l5.3-5.3L35.6,76.4L30.2,81.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualified);
export default __webpack_public_path__ + "static/media/qualified.08c1c6ecd8a8a38157ba23e119d2d40f.svg";
export { ForwardRef as ReactComponent };